import {
    CHANGE_ACTIVE_AD_MODAL,
    TOGGLE_MODAL,
} from '../actions/actionTypes';

const initialState = {
    activeModal: null,
    modals: {
        bannerModal: false,
        carouselModal: false,
        errorModal: false,
        successModal: false,
    },
};

const changeActiveModal = (state, action) => ({
    ...state,
    activeModal: action.modalName,
});

const toggleModal = (state, action) => ({
    ...state,
    modals: {
        ...state.modals,
        [action.modalName]: action.value,
    },
});

const modalReducer = (state = initialState, action) => {
    let newState = {};

    switch (action.type) {
    case CHANGE_ACTIVE_AD_MODAL: newState = changeActiveModal(state, action); break;
    case TOGGLE_MODAL: newState = toggleModal(state, action); break;
    default:
        newState = state;
    }
    return newState;
};

export default modalReducer;
